import axios from 'axios';
import {
  GET_SERIALS_FILTER,
  GET_FILTERED_SERIALS,
  CLEAR_FILTERED_SERIALS,
  GET_SERIAL,
  GET_SERIAL_EPISODES,
  GET_SERIAL_THREAD,
  CLEAR_SERIAL_DATA,
  GET_NEW_SERIALS,
  GET_LAST_SERIALS,
  GET_TOP_SERIALS,
  GET_RECOMMENDED_SERIALS,
} from '../constants';

export const getSerialsFilterSuccess = response => ({
  type: GET_SERIALS_FILTER,
  response,
});

export const getSerialsFilter = () => dispatch => (
  axios.get('/videos/serials/filter')
    .then((response) => {
      const data = {
        status: response.status,
        data: response.data.data,
      };
      return dispatch(getSerialsFilterSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getSerialsFilterSuccess(data));
    })
);

export const getFilteredSerialsSuccess = response => ({
  type: GET_FILTERED_SERIALS,
  response,
});

export const getFilteredSerials = (page = 1, genre = '', country = '', year = '', language = '') => dispatch => (
  axios.get(`/videos/serials?page=${page}&size=12&genre=${genre}&country=${country}&year=${year}&language=${language}`)
    .then((response) => {
      const data = {
        status: response.status,
        pageLoaded: page,
        hasNext: response.data.pages !== 0 && response.data.pages !== page,
        data: response.data.data,
      };
      return dispatch(getFilteredSerialsSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getFilteredSerialsSuccess(data));
    })
);

export const clearFilteredSerials = () => ({
  type: CLEAR_FILTERED_SERIALS,
});

export const clearSerialData = () => ({
  type: CLEAR_SERIAL_DATA,
});

export const getSerialThreadSuccess = response => ({
  type: GET_SERIAL_THREAD,
  response,
});

export const getSerialThread = id => dispatch => (
  axios.get(`/videos/media/thread/${id}`)
    .then((response) => {
      const data = {
        status: response.status,
        data: response.data.data,
      };
      return dispatch(getSerialThreadSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: {},
      };
      if (error.response) {
        data.status = error.response.status;
        data.data = error.response.data;
      } else if (error.request) {
        data.status = 0;
        data.data = error.response.data;
      } else {
        data.status = 0;
      }
      dispatch(getSerialThreadSuccess(data));
    })
);

export const getSerialEpisodesSuccess = response => ({
  type: GET_SERIAL_EPISODES,
  response,
});

export const getSerialEpisodes = id => dispatch => (
  axios.get(`/videos/serial/episodes/${id}?size=100`)
    .then((response) => {
      const data = {
        status: response.status,
        data: response.data.data.reverse(),
      };

      dispatch(getSerialThread(data.data[0].id));

      return dispatch(getSerialEpisodesSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: (error.response && error.response.data) || [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getSerialEpisodesSuccess(data));
    })
);


// export const getSerialEpisodes = seasons =>
//   (dispatch) => {
//     axios.all(seasons.map(season => axios.get(`/videos/serial/episodes/${season.id}?size=100`)))
//       .then((response) => {
//         const data = {
//           status: 200,
//           data: response.map(item => item.data.data),
//         };

//         return dispatch(getSerialEpisodesSuccess(data));
//       });
//   };

export const getSerialSuccess = response => ({
  type: GET_SERIAL,
  response,
});

export const getSerial = id => dispatch => (
  axios.get(`/videos/serial/${id}`)
    .then((response) => {
      dispatch(getSerialEpisodes(response.data.data.seasons[0].id));
      const data = {
        status: response.status,
        data: response.data.data,
      };
      return dispatch(getSerialSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: {},
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getSerialSuccess(data));
    })
);

export const getNewSerialsSuccess = response => ({
  type: GET_NEW_SERIALS,
  response,
});

export const getNewSerials = (page = 1, size = 15) => dispatch => (
  axios.get(`/videos/serials?order=new&page=${page}&size=${size}`)
    .then((response) => {
      const data = {
        status: response.status,
        pageLoaded: page,
        hasNext: response.data.pages !== page,
        data: response.data.data,
      };
      return dispatch(getNewSerialsSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getNewSerialsSuccess(data));
    })
);


export const getLastSerialsSuccess = response => ({
  type: GET_LAST_SERIALS,
  response,
});

export const getLastSerials = (page = 1, size = 15) => dispatch => (
  axios.get(`/videos/serials?order=last&page=${page}&size=${size}`)
    .then((response) => {
      const data = {
        status: response.status,
        pageLoaded: page,
        hasNext: response.data.pages !== page,
        data: response.data.data,
      };
      return dispatch(getLastSerialsSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getLastSerialsSuccess(data));
    })
);

export const getTopSerialsSuccess = response => ({
  type: GET_TOP_SERIALS,
  response,
});

export const getTopSerials = (page = 1, size = 15) => dispatch => (
  axios.get(`/videos/serials?order=top&page=${page}&size=${size}`)
    .then((response) => {
      const data = {
        status: response.status,
        pageLoaded: page,
        hasNext: response.data.pages !== page,
        data: response.data.data,
      };
      return dispatch(getTopSerialsSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getTopSerialsSuccess(data));
    })
);


export const getRecommendedSerialsSuccess = response => ({
  type: GET_RECOMMENDED_SERIALS,
  response,
});

export const getRecommendedSerials = (page = 1, size = 15) => dispatch => (
  axios.get(`/videos/serials?order=recommend&page=${page}&size=${size}`)
    .then((response) => {
      const data = {
        status: response.status,
        pageLoaded: page,
        hasNext: response.data.pages !== page,
        data: response.data.data,
      };
      return dispatch(getRecommendedSerialsSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getRecommendedSerialsSuccess(data));
    })
);
